import { useState } from 'react';
import { Paper, Modal, Stack, Text, Group } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useGetAllWorkoutCategoriesQuery, useUpdateWorkoutCategoryMutation } from '@codezo/graphql';
import { DataContainer, ScrollContainer } from '@codezo/ui';
import { CategoriesList } from '../components/CategoriesList';
import { CategoryUpdateForm } from '../components/CategoryUpdateForm';

export function CategoriesPage() {
	const [selectedCategory, setSelectedCategory] = useState<any | null>(null);
	const [updateModalOpened, setUpdateModalOpened] = useState(false);

	// Fetch categories with translations
	const { data, loading, refetch } = useGetAllWorkoutCategoriesQuery();
	const [updateCategory, { loading: updating }] = useUpdateWorkoutCategoryMutation();

	const handleEdit = (category: any) => {
		setSelectedCategory(category);
		setUpdateModalOpened(true);
	};

	const handleUpdateSubmit = async (values: any) => {
		try {
			await updateCategory({
				variables: {
					input: values,
				},
			});

			notifications.show({
				title: 'Success',
				message: 'Category updated successfully',
				color: 'green',
			});

			setUpdateModalOpened(false);
			setSelectedCategory(null);
			refetch();
		} catch (error: any) {
			notifications.show({
				title: 'Error',
				message: error.message || 'Failed to update category',
				color: 'red',
			});
		}
	};

	const handleCancel = () => {
		setUpdateModalOpened(false);
		setSelectedCategory(null);
	};

	const categories = data?.getAllWorkoutCategories || [];

	return (
		<ScrollContainer>
			<Stack gap="lg">
				<Group justify="space-between">
					<div>
						<Text size="lg" fw={600}>
							Workout Categories
						</Text>
						<Text size="sm" c="dimmed">
							Manage workout categories and their properties
						</Text>
					</div>
				</Group>

				<DataContainer loading={loading} error={undefined}>
					<Paper p="lg" withBorder style={{ overflow: 'hidden' }}>
						<CategoriesList categories={categories} onEdit={handleEdit} />
					</Paper>
				</DataContainer>
			</Stack>

			<Modal
				opened={updateModalOpened}
				onClose={handleCancel}
				title="Update Category"
				size="lg"
				styles={{
					body: { padding: 0, height: '70vh', display: 'flex', flexDirection: 'column' },
				}}
			>
				{selectedCategory && (
					<CategoryUpdateForm
						initialValues={selectedCategory}
						onSubmit={handleUpdateSubmit}
						onCancel={handleCancel}
						loading={updating}
					/>
				)}
			</Modal>
		</ScrollContainer>
	);
}
